<template>
 <modal-template
    ref="modal"
    modal-size="sm"
    title="Editar pergunta"
    type-modal="puzzle_edit_question_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

       <d-form-row class="form-group">
          <d-col cols="12">
            <label>Pergunta:</label>
            <textarea
              class="form-control"
              v-model="question.question"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>
      </d-form>
    </div>
    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary float-right"
      >
        Salvar
      </d-button>
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-4 float-right"
      >
        Cancelar
      </d-button>
    </div>
 </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import { _PUZZLE_EDIT_QUESTION_OPTION_ } from '../PuzzleModel';

export default {
  name: 'puzzle-edit-question-modal',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      question: {
        id: null,
        question: null,
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'puzzle_edit_question_modal', bool: false });
    },
    save() {
      PuzzleService.editQuestion(this.question)
        .then(() => {
          this.activeAlert({ message: 'Pergunta atualizada com sucesso!', theme: 'success' });
          this.close();
        });
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_EDIT_QUESTION_OPTION_);
  },
  mounted() {
    Events.$on(_PUZZLE_EDIT_QUESTION_OPTION_, question => {
      this.question = question;
    });
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 8000;
  &-content__control {
    width: 100%;
  }
}
</style>
